import axiosInstance from "./axiosInstance";

const API_URL = "/clothing-items";

export const getClothingItems = async (category = "") => {
  const response = await axiosInstance.get(API_URL, {
    params: category ? { category } : undefined,
  });
  return response.data.clothingItems;
};
export const getClothingItem = async (id) => (await axiosInstance.get(`${API_URL}/${id}`)).data.clothingItem;
export const generateClothingItemImage = async (id) => (await axiosInstance.post(`${API_URL}/${id}/generate-image`, {}, { timeout: 150000 })).data;

export const createClothingItem = async (formData) => {
  const response = await axiosInstance.post(API_URL, formData);
  return response.data.clothingItem;
};

export const updateClothingItem = async (id, formData) => {
  const response = await axiosInstance.patch(`${API_URL}/${id}`, formData);
  return response.data.clothingItem;
};

export const deleteClothingItem = async (id) => {
  const response = await axiosInstance.delete(`${API_URL}/${id}`);
  return response.data;
};

export const analyzeClothingImage = async (file) => {
  const data = new FormData();
  data.append("image", file);
  return (await axiosInstance.post(`${API_URL}/analyze-image`, data, { timeout: 30000 })).data.items;
};

export const confirmAnalyzedClothing = async (items, sourceFile) => {
  const data = new FormData();
  data.append("items", JSON.stringify(items));
  data.append("image", sourceFile);
  return (await axiosInstance.post(`${API_URL}/confirm-analysis`, data, { timeout: 60000 })).data.clothingItems;
};
export const generateClothingFromDescription = async (description, signal) =>
  (await axiosInstance.post(`${API_URL}/generate-from-description`, { description }, { signal, timeout: 150000 })).data.suggestion;
export const confirmGeneratedClothing = async (suggestion) =>
  (await axiosInstance.post(`${API_URL}/confirm-generated`, suggestion)).data.clothingItem;

export const recommendOutfit = async (selectedIds, mannequinType, options = {}) =>
  (await axiosInstance.post(`${API_URL}/recommendations`, { selected_item_ids: selectedIds, mannequin_type: mannequinType, ...options }, { timeout: 150000 })).data;
export const generateOutfit = async (selectedIds, mannequinType, recommendedOwnedIds = [], suggestedItems = [], reasoningSummary = "") =>
  (await axiosInstance.post(`${API_URL}/outfits`, { selected_item_ids: selectedIds, mannequin_type: mannequinType, recommended_owned_ids: recommendedOwnedIds, suggested_items: suggestedItems, reasoning_summary: reasoningSummary }, { timeout: 150000 })).data;
export const getOutfitProducts = async (outfitId) =>
  (await axiosInstance.get(`${API_URL}/outfits/${outfitId}/products`, { timeout: 30000 })).data;
